<template>
  <div class="flex flex-row gap-2 items-center truncate">
    <template v-if="!ownerDisplayName">
      <span class="truncate">--</span>
    </template>
    <template v-else>
      <RemovedUserIcon v-if="isOwnerDeleted" />
      <ProfileIcon
        v-else
        :data="ownerUser"
        :size="28"
        :font="12"
      />
      <RemovedUserLabel
        :name="ownerDisplayName"
        :is-deleted="isOwnerDeleted"
      />
    </template>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import ProfileIcon from "@/src/components/ProfileIcon.vue";
import RemovedUserIcon from "@/src/components/RemovedUserIcon.vue";
import RemovedUserLabel from "@/src/components/RemovedUserLabel.vue";

const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
  ownerKey: {
    type: String,
    default: "owner",
  },
});

const store = useStore();
const users = computed(() => store.getters["users/users"] || []);

const ownerDisplayName = computed(() => {
  return props.row[props.ownerKey] || "";
});

const ownerUser = computed(() => {
  if (!ownerDisplayName.value) return { name: "" };
  const lowerName = ownerDisplayName.value.toLowerCase();
  const found = users.value.find((u) => u.name?.toLowerCase() === lowerName);
  return found || { name: ownerDisplayName.value, avatar_color: props.row.avatar_color };
});

// Check for field-specific deleted flag first, then fall back to global is_owner_deleted
const isOwnerDeleted = computed(() => {
  const fieldSpecificFlag = `is_${props.ownerKey}_deleted`;
  if (props.row[fieldSpecificFlag] !== undefined) {
    return props.row[fieldSpecificFlag];
  }
  // Fall back to global flag for backward compatibility (standard owner field)
  return props.row.is_owner_deleted || false;
});
</script>
